var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "User",
            "fields": [],
            "messages": [
                {
                    "name": "SetPassword",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "UserSetPassword",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "BindType",
                                    "name": "bindType",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "thirdId",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "verifyCode",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "password",
                                    "id": 4
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "BindType",
            "values": [
                {
                    "name": "DEFAULT_TYPE",
                    "id": 0
                },
                {
                    "name": "MOBILE_PHONE",
                    "id": 1
                },
                {
                    "name": "QQ",
                    "id": 2
                },
                {
                    "name": "WEIXIN",
                    "id": 3
                },
                {
                    "name": "FACEBOOK",
                    "id": 4
                },
                {
                    "name": "SINA_WEIBO",
                    "id": 5
                },
                {
                    "name": "GOOGLE",
                    "id": 15
                },
                {
                    "name": "TWITTER",
                    "id": 16
                },
                {
                    "name": "EMAIL",
                    "id": 17
                }
            ]
        },
        {
            "name": "PushType",
            "values": [
                {
                    "name": "DEFAULT_PUSHTYPE",
                    "id": 0
                },
                {
                    "name": "IOS",
                    "id": 2
                },
                {
                    "name": "XIAOMI",
                    "id": 4
                },
                {
                    "name": "GETUI",
                    "id": 5
                },
                {
                    "name": "GOOGLE_PUSH",
                    "id": 6
                },
                {
                    "name": "GOOGLE_FCM",
                    "id": 10
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/resetpwd.js